<script lang="ts" setup>
  import {
    DROPDOWN_CONTEXT_KEY,
    DropdownApplyFooter,
    DropdownPanelScroll,
    TextInput,
    type TextInputType,
  } from '@tundr/ds-components';
  import { computed, inject, ref, watch } from 'vue';
  import { useFilters } from '../../../../composables';
  import type { TypedTextInputType } from '../../../../store';
  import { FilterTypes } from '../../../../utils';

  type searchValueType = string | number | undefined;

  const props = defineProps<{
    filterNamespace: string;
    filterLabel: string;
    filterFieldName: string;
    modelValue?: string | number;
    label?: string;
    placeholder?: string;
    type?: TypedTextInputType;
  }>();

  const inputType = computed<TextInputType>(() => props.type ?? 'text');

  defineOptions({
    inheritAttrs: false,
  });

  const dropdown = inject(DROPDOWN_CONTEXT_KEY, null);

  const currentFilterStore = useFilters(props.filterNamespace);

  const inputValue = ref<searchValueType>(props.modelValue);

  watch(
    () => props.modelValue,
    (value) => {
      inputValue.value = value;
    },
  );

  const emit = defineEmits<{
    'update:modelValue': [searchValueType];
  }>();

  const onApplyFilter = () => {
    emit('update:modelValue', inputValue.value);
    currentFilterStore.applyFilterValue({
      filterFieldName: props.filterFieldName,
      value: inputValue.value,
      filterType: FilterTypes.TYPED_TEXT,
    });
    dropdown?.close();
  };

  const handleChange = (val: string) => {
    inputValue.value = val;
    emit('update:modelValue', val);
  };
</script>

<template>
  <DropdownPanelScroll>
    <TextInput
      name="filterTypedText"
      :label="filterLabel"
      :model-value="inputValue != null ? String(inputValue) : ''"
      :placeholder="placeholder || ''"
      @update:model-value="handleChange"
      :type="inputType"
    />
  </DropdownPanelScroll>
  <DropdownApplyFooter :disabled="!inputValue" @apply="onApplyFilter" />
</template>
